import React from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Typography } from '@vibTheme/components/_base/Typography';
import { SegmentedToggle } from '@vibTheme/components/VibCharts/SegmentedToggle';
import {
  DashboardVersion,
  DashboardVersions,
} from '@interfaces/dashboardVersion';

// Ordem antiga → nova: é a linha do tempo, e evita que o avanço aponte para trás.
const OPTIONS = [
  { value: DashboardVersions.PREVIOUS, label: 'Dashboard Antiga' },
  { value: DashboardVersions.NEW, label: 'Dashboard Nova' },
];

// Serve às duas telas porque fala da versão nova em terceira pessoa.
const MESSAGE = 'Novos recursos de análise na nova versão.';

type Props = {
  version: DashboardVersion;
  onChange: (version: DashboardVersion) => void;
};

/** Acima do título: quem precisa da outra versão precisa antes de tentar ler a tela, não depois. */
export const DashboardVersionSwitch = ({ version, onChange }: Props) => (
  <div className="mb-main flex flex-col items-start gap-md rounded-default bg-white px-main py-[10px] shadow-default sm:flex-row sm:items-center sm:justify-between">
    <div className="flex items-center gap-sm">
      <AutoAwesomeIcon fontSize="small" className="text-primary" />
      <Typography className="text-sm">{MESSAGE}</Typography>
    </div>

    {/* Wrapper só para centrar o par no empilhado: o SegmentedToggle não recebe className. */}
    <div className="self-center sm:self-auto">
      <SegmentedToggle
        options={OPTIONS}
        value={version}
        onChange={onChange}
        label="Versão do dashboard"
        variant="pill"
      />
    </div>
  </div>
);
